export default "__VITE_ASSET__CBVJtlDU__"